import { createFileRoute } from '@tanstack/react-router';

type Search = {
  isNotification?: boolean;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/fax/$filter/$faxId')({
  validateSearch: (search: Search) => {
    return {
      isNotification: search.isNotification ?? false,
    };
  },
});
